<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal-container">
                <div class="modal-header">
                    <h2>Histórico de Produtos</h2>
                    <button class="close-btn" @click="$emit('close')">
                        <span class="material-icons-outlined">close</span>
                    </button>
                </div>

                <div class="modal-details-product">
                    <div class="modal-product-info">
                        <span class="product-title">
                            {{ capitalizeFirst(currentProductData.produtoDescricao) }}</span>
                        <div class="product-code">
                            <span>{{ currentProductData.pro_codInterno }}</span>
                        </div>
                        <div class="product-info-bottom" v-if="metricsData && metricsData.updatedAt">
                            <span>Atualizado em: {{ metricsData.updatedAt | formatDate }}</span>
                        </div>
                    </div>
                    <div class="modal-product-actions" v-if="!hide_data">
                        <div class="product-actions">
                            <!-- Botão Primeiro Pedido -->
                            <button @click="goToFirstProduct" :disabled="currentProductIndex === 0"
                                title="Primeiro Pedido">
                                <span class="material-icons-outlined">first_page</span>
                            </button>

                            <button @click="prevProduct" :disabled="currentProductIndex === 0">
                                <span class="material-icons-outlined">arrow_back_ios</span>
                            </button>

                            <span>Pedido {{ currentProductIndex + 1 }} de {{ products.length }}</span>

                            <button @click="nextProduct" :disabled="currentProductIndex === products.length - 1">
                                <span class="material-icons-outlined">arrow_forward_ios</span>
                            </button>

                            <!-- Botão Último Pedido -->
                            <button @click="goToLastProduct" :disabled="currentProductIndex === products.length - 1"
                                title="Último Pedido">
                                <span class="material-icons-outlined">last_page</span>
                            </button>
                        </div>
                        <div class="product-actions">
                            <select v-model="selectedDays">
                                <option v-for="day in daysOptions" :key="day" :value="day">
                                    Últimos {{ day }} dias
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="data-products" v-if="!hide_data">
                    <div class="space-modal">
                        <h5>Dados do Produto</h5>
                        <div class="space-modal-flex">
                            <span>Qtd. Requisitada: {{ currentProductData.quantidade }}</span>
                            <div class="unity" style="gap: 0;">
                                <div class="packing-actions">
                                    <input min="0" type="number" :class="{
                                        disabled: !!subrequest.id_pedido,
                                        saved: currentProductData.quantidade_sugestao === currentProductData.new_amount,
                                        lower:
                                            currentProductData.firstValue >
                                            currentProductData.quantidade_sugestao,
                                        higher:
                                            currentProductData.firstValue <
                                            currentProductData.quantidade_sugestao,
                                    }" :readonly="subrequest && !!subrequest.id_pedido"
                                        v-model="currentProductData.new_amount"
                                        @keydown="process_event_modal($event, currentProductData)"
                                        @blur="process_event_modal($event, currentProductData)"
                                        :aria-label="`Quantidade para ${currentProductData.produtoDescricao}`"
                                        :aria-disabled="!!subrequest.id_pedido" :disabled="!!subrequest.id_pedido"
                                        style="width: 4rem; text-align: center; box-sizing: border-box;" />
                                    <button type="button" class="save" :disabled="!!subrequest.id_pedido"
                                        @mousedown.prevent @click="update_quantity_modal(currentProductData)">
                                    </button>
                                    <span class="unit-text">
                                        {{
                                            currentProductData.pro_unidade_compra
                                                ? currentProductData.pro_unidade_compra
                                                : currentProductData.embalagem
                                                    ? currentProductData.embalagem.split(" ")[0]
                                                    : "UN"
                                        }} {{
                                            currentProductData.flag_generico == 1 || currentProductData.pro_principal
                                                ? currentProductData.quantidadeDigitacao
                                                : currentProductData.embalagem ? currentProductData.embalagem.split(" ")[1] :
                                                    "--"
                                        }}
                                    </span>
                                </div>
                                <div class="unit-edit-container" style="gap: 0;">
                                    <i class="far fa-edit" style="cursor: pointer; color: var(--primary-color)"
                                        @click="edit_wrap(currentProductData)" v-if="canEditUnit(currentProductData)"
                                        title="Editar unidade de compra" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <table class="history-table">
                        <thead>
                            <tr>
                                <th>Digitação</th>
                                <th>Ult. Compra</th>
                                <th>Diferença</th>
                                <th>Variação</th>
                                <th>Quantidade Total</th>
                                <th>Preço/Embalagem</th>
                                <th>Preço Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td data-label="Digitação">
                                    <span :style="getDigiTextColorStyle(currentProductData)">
                                        {{ currentProductData.menorPreco | customCurrency }}</span>
                                </td>
                                <td>
                                    {{
                                        (lastPurchaseForCurrentProduct
                                            ? lastPurchaseForCurrentProduct.valor
                                            : "--") | currency
                                    }}
                                </td>
                                <td data-label="Diferença">{{ getDiff(currentProductData) }}</td>
                                <td data-label="Variação" :class="getDiffColor(getDiffs(currentProductData))">
                                    {{ getVar(currentProductData) }}
                                </td>
                                <td data-label="Quantidade Total">
                                    {{ currentProductData.new_amount * (currentProductData.flag_generico == 1 ||
                                        currentProductData.pro_principal
                                        ? currentProductData.quantidadeDigitacao
                                        : currentProductData.embalagem ? currentProductData.embalagem.split(" ")[1] :
                                            0) }}
                                </td>
                                <td data-label="Preço/Embalagem">
                                    {{
                                        calculatePackagePrice(
                                            currentProductData.menorPreco,
                                            currentProductData
                                        ) | currency
                                    }}
                                </td>
                                <td>
                                    {{ (calculatePackagePrice(
                                        currentProductData.menorPreco,
                                        currentProductData
                                    ) * currentProductData.new_amount) | currency }}
                                </td>
                            </tr>
                            <tr v-if="lastPurchaseForCurrentProduct" class="summary-details-row">
                                <td colspan="7">
                                    <div class="summary-title pt-1 pb-1">
                                        <h5>Dados da Última Compra</h5>
                                    </div>
                                    <div class="cards-container">
                                        <div class="card-product">
                                            <p class="title">Última Compra</p>
                                            <p class="value">{{ formatDate(lastPurchaseForCurrentProduct.dataentrada) }}
                                            </p>
                                        </div>
                                        <div class="card-product">
                                            <p class="title">Qtd. Emb.</p>
                                            <p class="value">{{ lastPurchaseForCurrentProduct.qtdembalagem }}</p>
                                        </div>
                                        <div class="card-product">
                                            <p class="title">Qtd. Total</p>
                                            <p class="value">{{ lastPurchaseForCurrentProduct.quantidade_total }}
                                                unidade(s)</p>
                                        </div>
                                        <div class="card-product">
                                            <p class="title">Venda desde Utl. Compra</p>
                                            <p class="value">{{ salesSinceLastPurchase }} unidade(s)</p>
                                        </div>
                                        <div class="card-product">
                                            <p class="title">Saldo</p>
                                            <p class="value"
                                                :class="{ 'negative-value': estimatedStock < 0 }">
                                                {{ estimatedStock }} unidade(s)
                                            </p>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                </div>

                <div class="data-stock pt-2">
                    <h5>Dados do Estoque</h5>
                    <div class="cards-container">
                        <div v-for="(stock, index) in stocks" :key="index" class="card-stock">
                            <p class="title">{{ stock.title }}</p>
                            <p class="value" :class="{ 'negative-value': stock.isNegative }">{{ stock.value }}</p>
                        </div>
                    </div>
                </div>


                <div class="data-analysis">
                    <div class="summary-title pt-1 pb-1">
                        <h5>Análise Movimentação (últimos {{ selectedDays }} dias)</h5>
                    </div>
                    <div class="cards-container">
                        <div class="card-analysis">
                            <p class="title">Data da Ult. Venda</p>
                            <p class="value">{{ formattedLastSaleDate }}</p>
                        </div>
                        <div class="card-analysis">
                            <p class="title">Venda Total</p>
                            <p class="value">{{ comparativeAnalysis.sales.total }} uni.</p>
                        </div>
                        <div class="card-analysis">
                            <p class="title">Compra Total</p>
                            <p class="value">{{ comparativeAnalysis.purchases.total }} uni.</p>
                        </div>
                        <div class="card-analysis">
                            <p class="title">Saldo</p>
                            <p class="value"
                                :class="{ 'negative-value': comparativeAnalysis.purchases.total - comparativeAnalysis.sales.total < 0 }">
                                {{ comparativeAnalysis.purchases.total - comparativeAnalysis.sales.total }} uni.
                            </p>
                        </div>
                        <div class="card-analysis">
                            <p class="title">Giro Diário</p>
                            <p class="value">{{ comparativeAnalysis.sales.daily }} uni./dia</p>
                        </div>
                        <div class="card-analysis">
                            <p class="title">Média Semanal</p>
                            <p class="value">{{ comparativeAnalysis.sales.weekly }} uni./sem.</p>
                        </div>
                        <div class="card-analysis">
                            <p class="title">Média Mensal</p>
                            <p class="value">{{ comparativeAnalysis.sales.monthly }} uni./mês</p>
                        </div>
                    </div>
                </div>

                <div class="data-chart">
                    <h5>Vendas x Compras</h5>
                    <div class="chart-container" v-if="hasChartData">
                        <canvas ref="salesPurchasesChart"></canvas>
                    </div>
                    <div class="chart-empty" v-else>
                        <span class="material-icons-outlined">show_chart</span>
                        <p>Sem dados de vendas ou compras para o período selecionado</p>
                    </div>
                </div>

                <div class="data-purchase">
                    <h5>Últimas Compras</h5>
                    <div class="table-scroll-wrapper">
                        <table class="history-table">
                            <thead>
                                <tr>
                                    <th>Fornecedor</th>
                                    <th>Data de Compra</th>
                                    <th>Qtd./Embalagem</th>
                                    <th>Quantidade</th>
                                    <th>Quantidade Total</th>
                                    <th>N° da Nota</th>
                                    <th>Valor Embalagem</th>
                                    <th>Valor Und.</th>
                                    <th>Valor Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in filteredPurchaseHistory" :key="'purchase-' + index">
                                    <td data-label="Fornecedor" class="supplier">
                                        <span>{{ item.nomefantasia }}</span><span class="cnpj">{{ formatCNPJ(item.cnpj)
                                        }}</span>
                                    </td>
                                    <td data-label="Data de Comprar">{{ formatDate(item.dataentrada) }}</td>
                                    <td data-label="Qtd./Embalagem">{{ item.qtdembalagem }}</td>
                                    <td data-label="Quantidade">{{ item.quantidade }}</td>
                                    <td data-label="Quantidade Total">{{ item.quantidade_total }}</td>
                                    <td data-label="Nº da Nota">{{ item.id_notaentrada }}</td>
                                    <td data-label="Valor Embalagem">
                                        {{ (item.valor * item.qtdembalagem) | currency }}
                                    </td>
                                    <td data-label="Valor Und.">{{ item.valor | currency }}</td>
                                    <td data-label="Valor Total">{{ item.valortotal | currency }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <ProductWrapModal v-if="open_edit_wrap && current_product" :product="current_product" :salesman="salesman"
            @close="close_wrap" />
    </div>
</template>

<script>
import axios from "axios";
import Chart from "chart.js";
import Select from "../cliente/base-components/Select.vue";
import QuotationService from "@/services/QuotationService";
import ProductService from "@/services/v2/products.service";
import difLine from "../lists/difLine.vue";
import ProductWrapModal from "@/modals/product-wrap/product-wrap.modal";

export default {
    components: {
        Select,
        difLine,
        ProductWrapModal,
    },
    props: {
        storeNumber: {
            type: [String, Number],
            required: true,
        },
        clientId: {
            type: [String, Number],
            required: true,
        },
        productsList: {
            type: Array,
            required: true,
            default: () => [],
        },
        product: {
            type: Object,
            required: true,
        },
        salesman: {
            type: Object,
            default: null,
        },
        subrequest: {
            type: Object,
            required: true,
            default: () => ({ id_pedido: null }),
        },
        hide_data: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            products: [],
            currentProductIndex: 0,
            allPurchaseHistory: [],
            allSaleHistory: [],
            filteredPurchaseHistory: [],
            filteredSaleHistory: [],
            loading: false,
            periodFilter: "all",
            salesPeriodFilter: "all",
            apiBaseUrl: process.env.VUE_APP_MIRAI_BASE_URL || "https://api-integration.clubdacotacao.com.br/v3/intelligence",
            currentProduct: 1,
            totalProducts: 5,
            selectedDays: 90,
            daysOptions: [7, 14, 30, 90],
            isEditing: false,
            editedQuantity: 0,
            metricsData: null,
            purchasePending: 0,
            stocks: [],
            comparativeAnalysis: {
                sales: {
                    total: 0,
                    daily: 0,
                    weekly: 0,
                    monthly: 0
                },
                purchases: {
                    total: 0,
                    daily: 0,
                    weekly: 0,
                    monthly: 0
                }
            },
            quotationService: new QuotationService(),
            productService: new ProductService(),
            previousQuantity: 0,
            open_edit_wrap: false,
            current_product: null,
            chartInstance: null,
            hasChartData: false,
        };
    },
    created() {
        this.fetchInitialData();
    },
    computed: {
        lastSale() {
            const product = this.metricsData?.product;
            if (!product) return null;
            return { quantidade: product.last_sale_quantity, valortotal: product.last_sale_value };
        },
        formattedLastSaleDate() {
            const lastSaleDate = this.metricsData?.product?.last_sale;
            if (!lastSaleDate) return '--';
            return this.formatDate(lastSaleDate);
        },
        storeSalesMetrics() {
            const networkSales = this.metricsData?.network_sales || [];
            return networkSales.find(item => String(item.id_loja) === String(this.storeNumber)) || null;
        },
        formattedLastSaleQuantity() {
            if (!this.lastSale || !this.lastSale.quantidade) return '--';
            return this.lastSale.quantidade + ' uni.';
        },
        formattedLastSaleValue() {
            if (!this.lastSale || this.lastSale.valortotal == null) return '--';
            return this.$options.filters.currency(this.lastSale.valortotal);
        },
        currentProductData() {
            return this.products[this.currentProductIndex] || {};
        },
        quantityInput() {
            return this.product.quantidadeDigitacao || 0;
        },
        routeParams() {
            return {
                vendedorId: this.$route.params.sellerid,
                fornecedorId: this.$route.params.providerid,
                quotationId: this.$route.params.id,
            };
        },
        purchasesForCurrentProduct() {
            if (!this.filteredPurchaseHistory.length) return [];

            const currentProductId = this.currentProductData.pro_codInterno;

            if (!currentProductId) return [];

            const purchases = this.filteredPurchaseHistory.filter((purchase) => {
                return purchase.id_produto == currentProductId;
            });
            return purchases;
        },
        lastPurchaseForCurrentProduct() {
            if (this.purchasesForCurrentProduct.length > 0) {
                const sortedPurchases = [...this.purchasesForCurrentProduct].sort((a, b) => {
                    const dateA = new Date(a.dataentrada || a.dataemissao);
                    const dateB = new Date(b.dataentrada || b.dataemissao);
                    return dateB - dateA;
                });
                return sortedPurchases[0];
            }
            return null;
        },
        salesSinceLastPurchase() {
            return this.metricsData?.stock?.soldSinceLastPurchase || 0;
        },
        estimatedStock() {
            return this.metricsData?.stock?.estimated || 0;
        },
    },
    methods: {
        goToFirstProduct() {
            if (this.products.length > 0) {
                this.currentProductIndex = 0;
            }
        },

        goToLastProduct() {
            if (this.products.length > 0) {
                this.currentProductIndex = this.products.length - 1;
            }
        },
        calculateLastPurchasePrice(purchase) {
            if (!purchase || !purchase.valor) return 0;
            return purchase.valor * (purchase.qtdembalagem || 1);
        },
        calculatePackagePrice(unitPrice, product) {
            if (!unitPrice || !product) return 0;

            let quantityPerPackage = 1;

            if (product.embalagem) {
                const embParts = product.embalagem.split(" ");
                if (embParts.length > 1) {
                    quantityPerPackage = parseFloat(embParts[1]) || 1;
                }
            }
            return unitPrice * quantityPerPackage;
        },

        calculateTotalPrice(unitPrice, product) {
            if (!unitPrice || !product) return 0;

            const requestedQuantity =
                parseFloat(product.new_amount) || parseFloat(product.quantidade_sugestao) || 0;

            let quantityPerPackage = 1;
            if (product.embalagem) {
                const embParts = product.embalagem.split(" ");
                if (embParts.length > 1) {
                    quantityPerPackage = parseFloat(embParts[1]) || 1;
                }
            }

            return requestedQuantity * unitPrice * quantityPerPackage;
        },
        getDiff(produto) {
            if (localStorage.getItem("cli_utilizaPrecoBase") != 1) return "--";

            if (
                !produto ||
                !this.lastPurchaseForCurrentProduct ||
                !this.lastPurchaseForCurrentProduct.valor
            ) {
                return this.$options.filters.currency(0);
            }
            const lastPurchaseUnitPrice = this.lastPurchaseForCurrentProduct.valor;
            const digitacaoPrice = produto.menorPreco || 0;

            const difference = digitacaoPrice - lastPurchaseUnitPrice;

            return this.$options.filters.currency(difference);
        },
        getDiffs(product) {
            if (
                !product ||
                !this.lastPurchaseForCurrentProduct ||
                !this.lastPurchaseForCurrentProduct.valor
            ) {
                return 0;
            }

            const lastPurchaseUnitPrice = this.lastPurchaseForCurrentProduct.valor;
            const digitacaoPrice = product.menorPreco || 0;

            return digitacaoPrice - lastPurchaseUnitPrice;
        },

        getVar(product) {
            if (localStorage.getItem("cli_utilizaPrecoBase") != 1) return "--";
            if (!product) return "--";

            const diff = this.getDiffValue(product);

            let quantityPerPackage = 1;
            if (product.embalagem) {
                const embParts = product.embalagem.split(" ");
                if (embParts.length > 1) {
                    quantityPerPackage = parseFloat(embParts[1]) || 1;
                }
            }
            const requestedQuantity = parseFloat(product.quantidade_sugestao) || 0;
            const variation = diff * quantityPerPackage * requestedQuantity;

            return this.$options.filters.currency(variation);
        },
        getDigiTextColorStyle(product) {
            if (
                !product ||
                !product.menorPreco ||
                !this.lastPurchaseForCurrentProduct ||
                !this.lastPurchaseForCurrentProduct.valor
            ) {
                return "color: #605F5F; font-weight: 500; padding: 0.2rem; border-radius: 6px;";
            }

            const digitacaoUnitPrice = this.getNumber(product.menorPreco);
            const lastPurchaseUnitPrice = this.lastPurchaseForCurrentProduct.valor;

            if (digitacaoUnitPrice > lastPurchaseUnitPrice) {
                return "color: red; background-color: #FF80801A; border: 1px solid #FF5C5C; opacity: 0.5; padding: 0.2rem; border-radius: 16px;";
            }
            if (digitacaoUnitPrice < lastPurchaseUnitPrice) {
                return "color: green; background-color: rgb(214, 238, 214); border: 1px solid lightgreen; padding: 0.2rem; border-radius: 16px;";
            }
            return "color: #605F5F; font-weight: 500; padding: 0.2rem; border-radius: 16px;";
        },

        getNumber(value) {
            return typeof value === "number" ? value : parseFloat(value) || 0;
        },

        getDiffValue(produto) {
            if (
                !produto ||
                !this.lastPurchaseForCurrentProduct ||
                !this.lastPurchaseForCurrentProduct.valor
            ) {
                return 0;
            }

            const lastPurchaseUnitPrice = this.lastPurchaseForCurrentProduct.valor;
            const digitacaoUnitPrice = produto.menorPreco || 0;

            return digitacaoUnitPrice - lastPurchaseUnitPrice;
        },

        getDiffColor(diff) {
            if (diff > 0) return "diff-up";
            else if (diff < 0) return "diff-down";
            return "";
        },

        getEmbalagemUnit(embalagem) {
            if (!embalagem) return "UN";
            const parts = embalagem.split(" ");
            return parts.length > 0 ? parts[0] : "UN";
        },
        initializeProducts() {
            // Agora this.productsList já vem filtrado do componente pai
            this.products = [...this.productsList];

            const index = this.products.findIndex(
                (p) =>
                    p.idProduto === this.product.idProduto ||
                    p.pro_ean === this.product.pro_ean ||
                    p.pro_codInterno === this.product.pro_codInterno
            );

            if (index !== -1) {
                this.currentProductIndex = index;
            } else if (this.products.length > 0) {
                this.currentProductIndex = 0;
            }

            this.fetchInitialData();
        },
        async fetchInitialData() {
            await this.fetchProductMetrics();
            this.$nextTick(() => this.renderChart());
        },
        getProducts() {
            this.loading = true;

            var quotationService = QuotationService;
            quotationService
                .getProdutosDigitacaoComparativo(params.id, params.sellerid, params.sid)
                .then((response) => response.data)
                .then((data) => {
                    let productsArray = data.produtos;
                    productsArray.forEach((p) => {
                        p.new_amount = p.quantidade_sugestao;
                        p.firstValue = p.quantidade_sugestao;
                    });
                    this.products = productsArray;
                    this.total_items = data.total;
                    if (data.valorTotal) {
                        data.valorTotal.forEach((d) => (this.total_pre_orders += d.total));
                    }
                    this.loading = false;
                })
                .catch((error) => {
                    console.error("Erro ao carregar produtos:", error);
                    this.loading = false;
                });
        },
        nextProduct() {
            if (this.currentProductIndex < this.products.length - 1) {
                this.currentProductIndex++;
            }
        },

        prevProduct() {
            if (this.currentProductIndex > 0) {
                this.currentProductIndex--;
            }
        },

        async fetchProductMetrics() {
            try {
                this.loading = true;

                const productIdentifier = this.currentProductData.pro_codInterno;
                if (!productIdentifier) {
                    this.allPurchaseHistory = [];
                    this.filteredPurchaseHistory = [];
                    this.allSaleHistory = [];
                    this.filteredSaleHistory = [];
                    this.metricsData = null;
                    this.stocks = this.getEmptyStockData();
                    this.comparativeAnalysis = {
                        sales: { total: 0, daily: 0, weekly: 0, monthly: 0 },
                        purchases: { total: 0, daily: 0, weekly: 0, monthly: 0 }
                    };
                    this.loading = false;
                    return;
                }

                const clientId = process.env.VUE_APP_MIRAI_CLI_ID || this.clientId || this.$store.state.user.cli_id;
                const storeNumber = this.storeNumber;

                const url = `${this.apiBaseUrl}/product_metrics/${clientId}?id_loja=${storeNumber}&id_produto=${productIdentifier}`;

                const response = await axios.get(url);
                const metrics = response.data || {};
                this.metricsData = metrics;

                this.allPurchaseHistory = (metrics.purchases || []).sort((a, b) => {
                    const dateA = new Date(a.dataentrada || a.dataemissao);
                    const dateB = new Date(b.dataentrada || b.dataemissao);
                    return dateB - dateA;
                });
                this.applyPurchaseFilter();

                this.allSaleHistory = (metrics.sales || [])
                    .map((sale) => ({
                        ...sale,
                        quantidade: Number(sale.quantidade) || 0,
                        data: sale.data || sale.dataentrada,
                    }))
                    .sort((a, b) => {
                        const dateA = new Date(a.data);
                        const dateB = new Date(b.data);
                        return dateB - dateA;
                    });
                this.applySalesFilter();
            } catch (error) {
                console.error("Erro ao buscar métricas do produto:", error);
                if (error.response) {
                    console.error("Status:", error.response.status);
                    console.error("Data:", error.response.data);
                }
                this.allPurchaseHistory = [];
                this.filteredPurchaseHistory = [];
                this.allSaleHistory = [];
                this.filteredSaleHistory = [];
                this.metricsData = null;
                this.stocks = this.getEmptyStockData();
                this.comparativeAnalysis = {
                    sales: { total: 0, daily: 0, weekly: 0, monthly: 0 },
                    purchases: { total: 0, daily: 0, weekly: 0, monthly: 0 }
                };
            } finally {
                this.loading = false;
            }
        },

        getEmptyStockData() {
            return [
                { title: "Estoque Atual", value: "--" },
                { title: "Cobertura de Estoque", value: "--" },
                { title: "Pendência de Compra", value: "--" },
                { title: "Cobertura Prevista", value: "--" },
            ];
        },
        calculateStockData() {
            if (!this.metricsData) {
                this.stocks = this.getEmptyStockData();
                this.comparativeAnalysis = {
                    sales: { total: 0, daily: 0, weekly: 0, monthly: 0 },
                    purchases: { total: 0, daily: 0, weekly: 0, monthly: 0 }
                };
                return;
            }

            const currentStock = this.metricsData.stock?.current || 0;
            const stockCoverage = Number(this.metricsData.stock?.coverage) || 0;
            const purchasePending = this.metricsData.stock?.pending || 0;
            const weightedGiro = Number(this.storeSalesMetrics?.average) || 0;

            this.updateStockCards(
                currentStock,
                stockCoverage,
                purchasePending,
                weightedGiro
            );

            this.calculateSalesAnalysis();
        },

        calculateSalesAnalysis() {
            const totalSales = Number(this.storeSalesMetrics?.[`quantidade_total_${this.selectedDays}d`]) || 0;
            const dailyAverage = Number(this.storeSalesMetrics?.[`giro_medio_${this.selectedDays}d`]) || 0;

            this.updateAnalysisCards(dailyAverage, totalSales);
        },

        updateStockCards(currentStock, stockCoverage, purchasePending, weightedGiro) {
            const formattedPending = Number.isInteger(purchasePending)
                ? purchasePending
                : Math.ceil(purchasePending);

            const quantityInput = parseFloat(this.currentProductData.new_amount) || 0;
            const quantityToUse =
                this.currentProductData.flag_generico == 1 ||
                    (this.currentProductData.pro_principal == null &&
                        this.currentProductData.cli_tipoPedido == 1)
                    ? quantityInput
                    : quantityInput * (parseFloat(this.currentProductData.emb_quantidade) || 1);

            const forecastCoverage =
                weightedGiro > 0 && currentStock >= 0
                    ? (quantityToUse + currentStock) / weightedGiro
                    : 0;

            const formattedForecast = Number.isInteger(forecastCoverage)
                ? forecastCoverage
                : Math.ceil(forecastCoverage);

            const formattedStockCoverage = Number.isInteger(stockCoverage)
                ? stockCoverage
                : Math.ceil(stockCoverage);
            this.stocks = [
                {
                    title: "Estoque Atual",
                    value: `${currentStock} unidades`,
                },
                {
                    title: "Cobertura de Estoque",
                    value:
                        currentStock >= 0 && stockCoverage > 0
                            ? `${formattedStockCoverage} dias`
                            : "--",
                },
                {
                    title: "Pendência de Compra",
                    value: formattedPending > 0 ? `${formattedPending} unidades` : "--",
                },
                {
                    title: "Cobertura Prevista",
                    value: formattedForecast > 0 ? `${formattedForecast} dias` : "--",
                },
            ];
        },

        updateAnalysisCards(dailyAverage, totalSales) {
            const formattedTotalSales = Math.ceil(totalSales);
            const formattedDailyAverage = dailyAverage.toFixed(2);
            const weeklyAverage = (dailyAverage * 7).toFixed(2);
            const monthlyAverage = (dailyAverage * 30).toFixed(2);

            this.comparativeAnalysis.sales = {
                total: formattedTotalSales,
                daily: formattedDailyAverage,
                weekly: weeklyAverage,
                monthly: monthlyAverage
            };

            // Purchase analysis
            const cutoffDate = new Date();
            cutoffDate.setDate(cutoffDate.getDate() - this.selectedDays);
            cutoffDate.setHours(0, 0, 0, 0);

            const recentPurchases = this.allPurchaseHistory.filter((p) => {
                const dateStr = p.dataentrada || p.dataemissao;
                if (!dateStr) return false;
                const pDate = new Date(dateStr.replace(/-/g, '/'));
                return pDate >= cutoffDate;
            });

            const totalPurchases = recentPurchases.reduce(
                (sum, p) => sum + (parseFloat(p.quantidade_total) || 0),
                0
            );

            const dailyPurchases = this.selectedDays > 0 ? totalPurchases / this.selectedDays : 0;
            const weeklyPurchases = (dailyPurchases * 7).toFixed(2);
            const monthlyPurchases = (dailyPurchases * 30).toFixed(2);

            this.comparativeAnalysis.purchases = {
                total: Math.ceil(totalPurchases),
                daily: dailyPurchases.toFixed(2),
                weekly: weeklyPurchases,
                monthly: monthlyPurchases
            };
        },

        async updateProductData() {
            this.allPurchaseHistory = [];
            this.allSaleHistory = [];
            this.filteredPurchaseHistory = [];
            this.filteredSaleHistory = [];
            this.metricsData = null;

            const hasValidIdentifier =
                this.currentProductData.pro_ean || this.currentProductData.pro_codInterno;

            if (!hasValidIdentifier) {
                this.stocks = this.getEmptyStockData();
                this.comparativeAnalysis = {
                    sales: { total: 0, daily: 0, weekly: 0, monthly: 0 },
                    purchases: { total: 0, daily: 0, weekly: 0, monthly: 0 }
                };
                return;
            }

            await this.fetchProductMetrics();
            this.$nextTick(() => this.renderChart());
        },

        formatDate(dateString) {
            if (!dateString) return "--";
            const options = { day: "2-digit", month: "2-digit", year: "numeric" };
            return new Date(dateString).toLocaleDateString("pt-BR", options);
        },

        formatNumber(value) {
            return Number.isInteger(value) ? value : Math.trunc(value);
        },
        applyPurchaseFilter() {
            if (this.periodFilter === "all") {
                this.filteredPurchaseHistory = this.allPurchaseHistory;
            } else {
                const days = parseInt(this.periodFilter);
                const cutoffDate = new Date();
                cutoffDate.setDate(cutoffDate.getDate() - days);

                this.filteredPurchaseHistory = this.allPurchaseHistory.filter((item) => {
                    const itemDate = new Date(item.dataentrada || item.dataemissao);
                    return itemDate >= cutoffDate;
                });
            }
        },

        applySalesFilter() {
            if (this.salesPeriodFilter === "all") {
                this.filteredSaleHistory = this.allSaleHistory;
            } else {
                const days = parseInt(this.salesPeriodFilter);
                const cutoffDate = new Date();
                cutoffDate.setDate(cutoffDate.getDate() - days);

                this.filteredSaleHistory = this.allSaleHistory.filter((item) => {
                    const itemDate = new Date(item.data || item.dataentrada);
                    return itemDate >= cutoffDate;
                });
            }
        },
        process_event_modal(event, product) {
            if (event.type === "blur" || event.key === "Enter") {
                this.update_quantity_modal(product);
            }
        },

        update_quantity_modal(product) {
            if (!product || product.is_loading) return;

            if (!product.new_amount) product.new_amount = "0";

            let payload = {
                numerocotacao: this.$route.params.id,
                quantidade: product.new_amount,
                vendedor: this.$route.params.sellerid,
                produto: product.idProduto,
                loja: this.$route.params.sid,
            };

            this.$set(product, "is_loading", true);

            this.quotationService
                .update_quantity(payload)
                .then((response) => response.data)
                .then(
                    (data) => {
                        this.$set(product, "is_loading", false);
                        this.$set(product, "quantidade_sugestao", payload.quantidade);
                        this.$emit("quantity-updated");
                    },
                    (err) => {
                        this.$set(product, "is_loading", false);
                        console.error("Erro ao atualizar quantidade:", err);
                    }
                );
        },

        reload_subrequest_modal() {
            this.$emit("quantity-updated");
        },

        capitalizeFirst(str) {
            if (!str) return "";
            return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
        },
        canEditUnit(product) {
            return (
                product.flag_generico == 0 && !product.pro_principal && !this.subrequest.id_pedido
            );
        },

        edit_wrap(product) {
            this.current_product = product;
            this.open_edit_wrap = true;
        },

        close_wrap(reload = false) {
            this.current_product = null;
            this.open_edit_wrap = false;
            if (reload) {
                this.updateProductData();
            }
        },
        formatCNPJ(cnpj) {
            if (!cnpj) return "";
            cnpj = String(cnpj).padStart(14, "0");
            return cnpj
                .replace(/^(\d{2})(\d)/, "$1.$2")
                .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
                .replace(/\.(\d{3})(\d)/, ".$1/$2")
                .replace(/(\d{4})(\d)/, "$1-$2")
                .substring(0, 18);
        },

        renderChart() {
            if (this.chartInstance) {
                this.chartInstance.destroy();
                this.chartInstance = null;
            }

            const cutoffDate = new Date();
            cutoffDate.setDate(cutoffDate.getDate() - this.selectedDays);
            cutoffDate.setHours(0, 0, 0, 0);

            const dateMap = {};

            this.allSaleHistory.forEach(sale => {
                const dateRaw = sale.data || sale.dataentrada;
                if (dateRaw) {
                    const d = new Date(dateRaw);
                    if (d >= cutoffDate) {
                        const year = d.getFullYear();
                        const month = String(d.getMonth() + 1).padStart(2, '0');
                        const dayOfM = String(d.getDate()).padStart(2, '0');
                        const dateKey = `${year}-${month}-${dayOfM}`;

                        dateMap[dateKey] = dateMap[dateKey] || { sales: 0, purchases: 0 };
                        dateMap[dateKey].sales += Number(sale.quantidade) || 0;
                    }
                }
            });

            this.allPurchaseHistory.forEach(purchase => {
                const dateRaw = purchase.dataentrada;
                if (dateRaw) {
                    const d = new Date(dateRaw);
                    if (d >= cutoffDate) {
                        const year = d.getFullYear();
                        const month = String(d.getMonth() + 1).padStart(2, '0');
                        const dayOfM = String(d.getDate()).padStart(2, '0');
                        const dateKey = `${year}-${month}-${dayOfM}`;

                        dateMap[dateKey] = dateMap[dateKey] || { sales: 0, purchases: 0 };
                        dateMap[dateKey].purchases += Number(purchase.quantidade_total) || 0;
                    }
                }
            });

            const existingDates = Object.keys(dateMap).sort();
            if (existingDates.length === 0) {
                this.hasChartData = false;
                return;
            }

            this.hasChartData = true;

            this.$nextTick(() => {
                const canvas = this.$refs.salesPurchasesChart;
                if (!canvas) return;

                const startDate = new Date(existingDates[0].replace(/-/g, '/'));
                const endDate = new Date();
                endDate.setHours(0, 0, 0, 0);
                const sortedDates = [];
                for (let d = new Date(startDate); d <= endDate; d.setDate(d.getDate() + 1)) {
                    const year = d.getFullYear();
                    const month = String(d.getMonth() + 1).padStart(2, '0');
                    const dayOfMonth = String(d.getDate()).padStart(2, '0');
                    const iso = `${year}-${month}-${dayOfMonth}`;

                    sortedDates.push(iso);
                    if (!dateMap[iso]) dateMap[iso] = { sales: 0, purchases: 0 };
                }

                const salesData = sortedDates.map(d => dateMap[d].sales);
                const purchasesData = sortedDates.map(d => dateMap[d].purchases);
                const labels = sortedDates.map(d => {
                    const [y, m, day] = d.split('-');
                    return `${day}/${m}`;
                });

                const ctx = canvas.getContext('2d');
                this.chartInstance = new Chart(ctx, {
                    type: 'line',
                    data: {
                        labels,
                        datasets: [
                            {
                                label: 'Vendas (qtd)',
                                data: salesData,
                                borderColor: '#4CAF50',
                                backgroundColor: 'rgba(76, 175, 80, 0.1)',
                                borderWidth: 2,
                                pointRadius: 3,
                                pointBackgroundColor: '#4CAF50',
                                fill: true,
                                yAxisID: 'y-axis-1',
                            },
                            {
                                label: 'Compras (qtd)',
                                data: purchasesData,
                                borderColor: '#F44336',
                                backgroundColor: 'rgba(244, 67, 54, 0.1)',
                                borderWidth: 2,
                                pointRadius: 3,
                                pointBackgroundColor: '#F44336',
                                fill: true,
                                yAxisID: 'y-axis-2',
                            }
                        ]
                    },
                    options: {
                        responsive: true,
                        maintainAspectRatio: false,
                        scales: {
                            xAxes: [{
                                ticks: {
                                    fontSize: 10,
                                    maxRotation: 45,
                                    autoSkip: true,
                                    maxTicksLimit: 15
                                }
                            }],
                            yAxes: [
                                {
                                    id: 'y-axis-1',
                                    type: 'linear',
                                    position: 'left',
                                    ticks: {
                                        beginAtZero: true,
                                        precision: 0,
                                        fontColor: '#4CAF50'
                                    },
                                    scaleLabel: {
                                        display: true,
                                        labelString: 'Vendas (qtd)',
                                        fontColor: '#4CAF50'
                                    }
                                },
                                {
                                    id: 'y-axis-2',
                                    type: 'linear',
                                    position: 'right',
                                    ticks: {
                                        beginAtZero: true,
                                        precision: 0,
                                        fontColor: '#F44336'
                                    },
                                    gridLines: {
                                        drawOnChartArea: false
                                    },
                                    scaleLabel: {
                                        display: true,
                                        labelString: 'Compras (qtd)',
                                        fontColor: '#F44336'
                                    }
                                }
                            ]
                        },
                        legend: {
                            display: true,
                            position: 'top'
                        },
                        tooltips: {
                            mode: 'index',
                            intersect: false
                        }
                    }
                });
            });
        },
    },
    watch: {
        currentProductIndex: {
            handler() {
                this.updateProductData();
            },
            immediate: true,
            deep: true,
        },
        "currentProductData.new_amount": {
            handler(newQuantity, oldQuantity) {
                if (newQuantity !== oldQuantity) {
                    clearTimeout(this.quantityTimeout);
                    this.quantityTimeout = setTimeout(() => {
                        this.calculateStockData();
                    }, 300);
                }
            },
            immediate: true,
        },

        quantityInput() {
            this.calculateStockData();
        },
        metricsData() {
            this.calculateStockData();
        },
        selectedDays: {
            handler() {
                this.calculateStockData();
                this.calculateSalesAnalysis();
                this.$nextTick(() => this.renderChart());
            },
            immediate: true,
        },
    },
    filters: {
        currency(value) {
            if (value === null || value === undefined || isNaN(value)) return "R$ 0,00";
            const numValue = typeof value === "string" ? parseFloat(value) : value;
            return "R$ " + numValue.toFixed(2).replace(".", ",");
        },
        customCurrency(value) {
            if (value === null || value === undefined || isNaN(value)) return "R$ 0,00";
            const numValue = typeof value === "string" ? parseFloat(value) : value;
            return "R$ " + numValue.toFixed(2).replace(".", ",");
        },
    },
    mounted() {
        this.initializeProducts();
    },
    beforeUnmount() {
        if (this.chartInstance) {
            this.chartInstance.destroy();
            this.chartInstance = null;
        }
    },
};
</script>

<style lang="scss" scoped>
.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    transition: opacity 0.3s ease;
    padding: 20px;
}

.modal-wrapper {
    width: 95%;
    max-width: 70vw;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    max-height: 75vh;
}

.modal-container {
    background-color: #fff;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    height: 120vh;
    overflow-y: scroll;
    scrollbar-gutter: stable;

    &::-webkit-scrollbar {
        width: 3px;
        height: 4px;
    }

    &::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb {
        background: #c1c1c1;
        border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb:hover {
        background: #a8a8a8;
    }
}

.modal-header {
    padding: 16px 20px;
    color: #3a3a3c;
    border-radius: 8px 8px 0 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: none;
    background: white;
    flex-shrink: 0;
    position: sticky;
    top: 0;
    z-index: 100;

    h2 {
        margin: 0;
        font-size: 1rem;
        font-weight: 600;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        max-width: calc(100% - 40px);
    }
}

.close-btn {
    background: #3a3a3c;
    border-radius: 50%;
    border: none;
    color: white;
    cursor: pointer;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.modal-details-product {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin: 0;
    padding: 16px 20px;
    border-bottom: 1px solid #c7c9d9;
    background: white;
    flex-shrink: 0;
    position: sticky;
    z-index: 90;
}

.modal-product-info {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px 16px;

    .product-info-bottom {
        flex-basis: 100%;
        font-size: 0.875rem;
        color: #605f5f;
    }

    .product-title {
        color: #3a3a3c;
        font-size: 1rem;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        letter-spacing: -0.4px;
        text-transform: capitalize;
    }

    .product-code {
        display: flex;
        padding: 4px 8px;
        justify-content: center;
        align-items: center;
        gap: 10px;
        border-radius: 16px;
        border: 1px solid #c7c9d9;
        background: #f2f2f5;

        span {
            color: #605f5f;
            font-size: 0.875rem;
            font-style: normal;
            font-weight: 300;
            line-height: normal;
        }
    }
}

.modal-product-actions {
    display: flex;
    align-items: center;
    gap: 16px;
}

.product-actions {
    display: flex;
    height: 30px;
    padding: 12px;
    align-items: center;
    gap: 8px;
    border-radius: 8px;
    border: 1px solid #c7c9d9;
    background: #f2f2f5;
}

.packing-actions {
    display: flex;
    padding: 0 10px 0 0;
    align-items: center;
    gap: 6px;
    border-radius: 8px;
    border: 1px solid #c7c9d9;
    background: #f2f2f5;
}

.unity {
    display: flex;
    align-items: center;
    gap: 12px;
}

.unit-text {
    font-weight: 500;
    color: #3a3a3c;
    white-space: nowrap;
}

.unit-edit-container {
    display: flex;
    align-items: center;
    gap: 8px;
    padding-left: 4px;
}

.save {
    background: none;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    color: #333;
}

@keyframes inputWave {
    from {
        background-position: 0 calc(100% - 3px);
    }

    to {
        background-position: 24px calc(100% - 3px);
    }
}

.product-actions select {
    background: none;
    border: none;
}

.product-actions select:active {
    border: none;
}

.product-actions button {
    background: none;
    border: none;
    cursor: pointer;
}

.product-actions span {
    color: #3a3a3c;
    font-size: 0.875rem;
    font-weight: 400;
}

.quantity-input {
    width: 60px;
    border: none;
    background: transparent;
    outline: none;
    font-size: 0.875rem;
    text-align: right;
}

.modal-body {
    padding: 20px;
    overflow-y: auto;
    flex: 1;
}

.tab-container {
    display: flex;
    border-bottom: 1px solid #e0e0e0;
    margin-bottom: 20px;
    flex-shrink: 0;
}

.tab-btn {
    padding: 10px 20px;
    background: none;
    border: none;
    cursor: pointer;
    font-weight: 500;
    color: #605f5f;
    position: relative;
}

.tab-btn.active {
    color: #FF5722;
}

.tab-btn.active::after {
    content: "";
    position: absolute;
    bottom: -1px;
    left: 0;
    width: 100%;
    height: 3px;
    background-color: #FF5722;
}

.space-modal {
    display: flex;
    justify-content: space-between;
    margin-bottom: 0px;
}

.space-modal-flex {
    display: flex;
    align-items: center;
    gap: 12px;

    span {
        color: #3a3a3c;
        font-size: 0.875rem;
        font-weight: 500;
    }
}

.data-products {
    padding: 0px 10px 10px;
    width: 100%;
    position: sticky;
    z-index: 80;
    background: white;
    border-bottom: 1px solid #c7c9d9;
}


@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.empty-state {
    text-align: center;
    padding: 40px 0;
    color: #666;
    font-size: 1rem;
}

.table-responsive {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    max-height: 400px;
}

.history-table {
    width: 100%;
    margin: 5px auto;
    border-collapse: collapse;
    color: #605f5f;
    font-size: 0.6rem;
    font-weight: 500;

    th {
        height: 40px;
        text-align: center;
        position: sticky;
        top: 0;
        white-space: nowrap;
        border-bottom: 1px solid #c7c9d9;
        background-color: white;
    }

    td {
        padding: 10px;
        text-align: center;
        font-weight: 500;
        white-space: nowrap;
    }

    .supplier {
        display: flex;
        flex-direction: column;

        .cnpj {
            font-weight: 300;
        }

        @media (max-width: 768px) {
            flex-direction: row;
            align-items: center;
            gap: 8px;

            .cnpj {
                margin: 0;
            }
        }
    }

    .last-purchase-row {
        background-color: white;
        border-top: 1px solid #c7c9d9;
    }
}

.data-analysis .history-table {
    border: 1px solid #c7c9d9;
    border-collapse: collapse;

    th,
    td {
        border: 1px solid #c7c9d9;
    }

    th {
        background-color: #f8f9fa;
    }
}

.data-purchase .history-table {

    th:first-child,
    td:first-child {
        text-align: left !important;
        padding-left: 15px;
    }
}

.last-purchase-summary {
    margin-top: 1.5rem;

    h4 {
        margin-bottom: 0.8rem;
        font-weight: 600;
        color: #3a3a3c;
        font-size: 1rem !important;
    }
}

.data-stock,
.data-analysis {
    display: flex;
    flex-direction: column;
    padding: 10px 20px;
}

.cards-container {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.card-stock,
.card-analysis,
.card-product {
    flex: 1;
    border-radius: 8px;
    padding: 8px 12px;
    text-align: left;
    border: 1px solid #c7c9d9;
    margin-top: 6px;
    background: white;

    .title {
        color: #605F5F;
        font-size: 0.75rem;
        font-weight: 500;
        margin-bottom: 4px;
    }

    .value {
        color: #FF5722;
        font-weight: 700;
        font-size: 0.7rem;
    }

    &.negative-value {
        .value {
            color: red;
        }
    }
}

.negative-value {
    color: red !important;
}

.card-stock {
    background: #fff7e3;
}

.data-analysis {
    padding: 10px 20px;
}

.data-chart {
    padding: 0px 20px 5px;

    h4 {
        margin-bottom: 6px;
    }

    .chart-container {
        position: relative;
        height: 220px;
        width: 100%;
    }

    .chart-empty {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 110px;
        border: 1px dashed #c7c9d9;
        border-radius: 8px;
        color: #999;

        .material-icons-outlined {
            font-size: 36px;
            margin-bottom: 8px;
        }

        p {
            font-size: 0.875rem;
            margin: 0;
        }
    }
}

.data-purchase {
    padding: 14px 20px 0px;

    .table-scroll-wrapper {
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
    }
}

.diff-up {
    color: red;
    font-weight: bold;
}

.diff-down {
    font-weight: bold;
    color: green;
}

.unity {
    box-sizing: unset;

    .fa-edit {
        margin-left: 10px;
        color: var(--primary-color);
        cursor: pointer;
    }

    .unity-wrapper {
        display: inline-block;
        width: 86px;

        img {
            height: 18px;
        }

        input[type="number"] {
            border-radius: 10px 0 0 10px;
            border-width: 0;
            width: 50px;
            border: 4px solid #0606064d;
            display: inline-block;
            text-align: center;

            &:focus {
                border: 3px solid var(--primary-color);
                outline: none;
                box-shadow: 0px 0px 0px 3px var(--primary-color) inset;
            }

            &.higher {
                background-color: #13c7213d;
            }

            &.lower {
                background-color: #13c7213d;
            }
        }

        button {
            background: none;
            border: none;
            display: flex;
            align-items: center;
            justify-content: center;

            .fa-arrow-up {
                color: #0033ef9e;
            }

            .fa-arrow-down {
                color: #fb7272;
            }

            &.save {
                float: right;
                color: green;
                height: 32px;
                padding: 4px;
                position: relative;
                left: -12px;
                border-left: none;
                width: 1.5rem;
                border-radius: 0px 10px 10px 0px !important;

                i {
                    border-color: #0606064d;
                    left: 0.4rem;
                    position: absolute;
                    font-size: 0.9rem;
                    margin: 0;
                }
            }
        }
    }
}

.product-actions {
    button {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 4px;
        border-radius: 4px;
        transition: background-color 0.2s ease;

        &:hover:not(:disabled) {
            background-color: rgba(0, 0, 0, 0.1);
        }

        &:disabled {
            opacity: 0.5;
            cursor: not-allowed;
        }

        .material-icons-outlined {
            font-size: 18px;
        }
    }
}

@media (max-width: 768px) {
    .modal-wrapper {
        width: 100%;
        margin: 0;
    }

    .modal-container {
        height: auto;
        max-height: 90vh;
    }

    .modal-header h2 {
        font-size: 1.1rem;
    }

    .tab-btn {
        padding: 8px 15px;
        font-size: 0.85rem;
    }

    .modal-details-product {
        flex-direction: column;
        align-items: flex-start;
        gap: 16px;
    }

    .cards-container {
        flex-direction: column;
    }

    .history-table {
        display: block;
        width: 100%;

        thead {
            display: none;
        }

        tbody {
            display: block;
            width: 100%;
        }

        tr {
            display: block;
            margin-bottom: 15px;
            border: 1px solid #ddd;
            border-radius: 5px;
            padding: 10px;
        }

        td {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 8px 10px;
            border-bottom: 1px solid #eee;
            text-align: right;

            &::before {
                content: attr(data-label);
                color: #333;
                margin-right: 15px;
            }
        }

        td:last-child {
            border-bottom: none;
        }
    }

    .space-modal {
        display: flex;
        flex-wrap: wrap;
    }
}

@media (max-width: 480px) {
    .modal-header {
        padding: 12px 15px;

        h2 {
            font-size: 1rem;
        }
    }

    .modal-body {
        padding: 15px;
    }

    .tab-btn {
        padding: 6px 10px;
        font-size: 0.8rem;
    }

    .history-table td {
        font-size: 0.85rem;
        padding: 6px 8px;
    }
}

.summary-details-row {
    background-color: white;
    border-top: 1px solid #eef0f2;

    td {
        padding: 8px 20px 12px !important;
        text-align: left !important;
    }

    .summary-title {
        h4 {
            margin: 0;
            color: #3a3a3c;
            font-size: 1rem;
            font-weight: 600;
        }
    }
}

.saved {
    background-color: #13c7213d;
    border: 1px solid white;
    border-radius: 7px;
}
</style>
